const FLOATING_ELEMENT_SIDE_OFFSET = 6;
const FLOATING_ELEMENT_COLLISION_PADDING = 10;
const EMOJI_FONT_FAMILY = "'Apple Color Emoji', 'Noto Color Emoji', 'Twemoji Mozilla', 'Android Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', EmojiSymbols, sans-serif";

export { EMOJI_FONT_FAMILY, FLOATING_ELEMENT_COLLISION_PADDING, FLOATING_ELEMENT_SIDE_OFFSET };
//# sourceMappingURL=constants.mjs.map
